import {ChangeDetectorRef, Component, ElementRef, Renderer2, ViewChild} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {ModifaceFilter} from 'src/app/data/networking/models/modiface/modiface-config';
import {ProductInterface} from 'src/app/data/networking/models/shared/responses/product-response';
import {VtoPlayerVm} from 'src/app/view-model/vto-player/vto-player.vm';

declare function startTryOn(mode: string, filters: ModifaceFilter[]): void;

@Component({
  selector: 'app-vto-player',
  templateUrl: './vto-player.component.html',
  styleUrls: ['./vto-player.component.scss'],
})
export class VtoPlayerComponent {
  @ViewChild('swatchContainer', {static: false}) swatchContainer: ElementRef<HTMLUListElement>;

  startTime = 0;
  currentProduct: ProductInterface;
  visible = false;
  originalParent: Node;
  nextSibling: Node | null;
  hostEl: HTMLElement;

  constructor(
    private vm: VtoPlayerVm,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private el: ElementRef<HTMLElement>,
  ) {
    this.hostEl = this.el.nativeElement;
  }

  start(product: ProductInterface) {
    this.currentProduct = product;
    this.startTime = Date.now();
    this.originalParent = this.hostEl.parentNode;
    this.nextSibling = this.hostEl.nextSibling;
    this.renderer.appendChild(document.body, this.hostEl);

    this.visible = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.initMakeup();
    }, 0);
  }

  initMakeup() {
    const container = this.swatchContainer?.nativeElement;
    if (!container) return;

    let html = '';
    const filters = [];

    if (this.currentProduct.colors?.length > 0) {
      for (let i = 0; i < this.currentProduct.colors.length; i++) {
        const index = i + 1;
        html += `
          <li><a href="javascript:void(0)">
            <span id="color${index}"
              class="${this.currentProduct.filterCategories}-swatch"
              onclick="toggleMakeup('${this.currentProduct.filterCategories}', 'color${index}', '${this.currentProduct.colors[i].hex}')">
            </span></a>
          </li>`;

        filters.push({
          key: `color${index}`,
          value: this.currentProduct.colors[i].hex,
          filterCategory: this.currentProduct.filterCategories,
        });
      }
    }

    document.getElementById('lipcolor-swatch-container').innerHTML = html;

    container.innerHTML = html;
    startTryOn('live', filters);

    document.getElementById('body-vto-app').classList.remove('hide');
  }

  stop() {
    const endTime = Date.now();
    const timeUseSeconds = Math.floor((endTime - this.startTime) / 1000);

    this.logEvent(timeUseSeconds);
    this.visible = false;
  }

  logEvent(timeUseModiface: number) {
    this.vm
      .logEvent(this.currentProduct, timeUseModiface)
      .pipe(
        catchError(error => {
          console.error('Error logging event:', error);
          return null;
        }),
      )
      .subscribe();
  }
}
